import React from 'react';
import { useTranslation } from '@omilia/providers';
import { useSelector } from 'react-redux';
import { getLocale } from 'store/services/session/selectors';
import {
  SChatEnded,
  SDownloadPDF,
  SDownloadPDFContainer,
  SPdfIcon,
} from './DownloadPDFMessage.styled';
import TranscriptPDF from 'components/TranscriptPDF';
import { colors } from '@omilia/theme';

const DownloadPDFMessage = ({
  thread,
  title,
}: {
  thread: any[];
  title: string;
}) => {
  const { t } = useTranslation();
  const locale = useSelector(getLocale);

  return (
    <SDownloadPDFContainer>
      <SChatEnded>{t('downloadPdf.chatEnded')}</SChatEnded>
      <SDownloadPDF
        document={
          <TranscriptPDF thread={thread} title={title} locale={locale} />
        }
        fileName={t('files.fileName')}
      >
        <SPdfIcon size="12" color={colors.COLOR_BLUE_700} />{' '}
        {t('downloadPdf.downloadAsPdf')}
      </SDownloadPDF>
    </SDownloadPDFContainer>
  );
};

export default DownloadPDFMessage;
